import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DriverPortalSessionService } from './driver-portal-session.service';

@Injectable()
export class DriverPortalInterceptor implements HttpInterceptor {
  constructor(private session: DriverPortalSessionService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.headers.has('X-Driver-Portal')) { return next.handle(request); }
    const isPublicRequest = [
      '/TermAndPolicy',
      '/UserApp/SendSMSCode',
      '/UserApp/SendWhatsAppCode',
      '/UserApp/ValidadeSMSCode'
    ].some(path => request.url.includes(path));
    if (isPublicRequest) { return next.handle(request); }

    const isTermsStatusRequest = request.method === 'GET' && request.url.includes('/UserApp/term-and-policy/');
    if (isTermsStatusRequest && this.session.isAuthenticated && this.session.current) {
      return next.handle(request.clone({
        setHeaders: { Authorization: this.session.current.token }
      }));
    }
    const isTripRequest = request.method === 'GET' && request.url.includes('/Trip');
    const headers: { [name: string]: string } = {};
    if (!isTripRequest) { headers.language = 'pt-BR'; }
    if (this.session.isAuthenticated && this.session.current) {
      headers.Authorization = `Bearer ${this.session.current.token}`;
    }
    return next.handle(request.clone({ setHeaders: headers }));
  }
}
